<div class="chat">
  <div class="chat__header">
    <h3 class="chat__title">{{ titleText }}</h3>
  </div>

  <div class="chat__body">
    <div *ngIf="loading" class="chat__state">{{ loadingText }}</div>
    <div *ngIf="loadError" class="chat__state chat__state--error">{{ loadError }}</div>

    <ng-container *ngIf="!loading && !loadError">
      <button
        *ngIf="hasMore"
        type="button"
        class="chat__load-more"
        [disabled]="loadingMore"
        (click)="loadMore()"
      >
        {{ loadMoreText }}
      </button>

      <div *ngIf="messages.length === 0" class="chat__state">{{ emptyText }}</div>

      <div class="chat__messages">
        <ng-container *ngFor="let message of messages; let i = index">
          <div *ngIf="isNewDay(i)" class="chat__day-divider"><span>{{ dayLabel(message.createdAt) }}</span></div>

          <div class="chat__row" [class.chat__row--own]="isOwn(message)" [class.chat__row--menu-up]="messages.length > 2 && i >= messages.length - 2">
            <div class="chat__avatar" *ngIf="!isOwn(message)" [style.background]="avatarColor(message.sender.id)">
              {{ initials(message.sender) }}
            </div>

            <div class="chat__bubble-wrap">
              <div class="chat__bubble" [class.chat__bubble--own]="isOwn(message)" [class.chat__bubble--deleted]="message.deleted">

                <ng-container *ngIf="!message.deleted; else deletedTpl">
                  <div class="chat__sender" *ngIf="!isOwn(message)">{{ senderLabel(message.sender) }}</div>

                  <div *ngIf="message.replyToMessageId" class="chat__reply-quote">
                    <div class="chat__reply-sender">{{ message.replyToSender ? senderLabel(message.replyToSender) : '' }}</div>
                    <div class="chat__reply-text">{{ message.replyToSnippet || originalDeletedText }}</div>
                  </div>

                  <ng-container *ngIf="editingMessageId === message.id; else viewMode">
                    <textarea class="chat__edit-textarea" [(ngModel)]="editDraft" rows="2"></textarea>
                    <div class="chat__edit-actions">
                      <button type="button" class="chat__text-btn" (click)="cancelEdit()">{{ cancelText }}</button>
                      <button type="button" class="chat__text-btn chat__text-btn--primary" (click)="saveEdit(message)">{{ saveText }}</button>
                    </div>
                  </ng-container>

                  <ng-template #viewMode>
                    <div *ngIf="message.body" class="chat__text">{{ message.body }}</div>

                    <div *ngFor="let file of message.attachments" class="chat__attachment" (click)="downloadFile(file)">
                      <span class="chat__attachment-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                      </span>
                      <div class="chat__attachment-info">
                        <div class="chat__attachment-name">{{ file.fileName }}</div>
                        <div class="chat__attachment-size">{{ formatFileSize(file.fileSize) }}</div>
                      </div>
                    </div>

                    <div class="chat__bubble-footer">
                      <span *ngIf="message.edited" class="chat__edited">{{ editedText }}</span>
                      <span class="chat__time">{{ formatTime(message.createdAt) }}</span>
                    </div>
                  </ng-template>
                </ng-container>

                <ng-template #deletedTpl>
                  <div class="chat__deleted-text">{{ deletedText }}</div>
                </ng-template>
              </div>

              <div class="chat__menu-anchor" *ngIf="!message.deleted && editingMessageId !== message.id">
                <button
                  type="button"
                  class="chat__menu-trigger"
                  [attr.aria-label]="messageActionsText"
                  (click)="toggleMenu($event, message)"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
                </button>

                <div class="chat__menu" *ngIf="openMenuMessageId === message.id" (click)="$event.stopPropagation()">
                  <button *ngIf="!locked" type="button" (click)="startReply(message)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/></svg>
                    {{ replyText }}
                  </button>
                  <ng-container *ngIf="isOwn(message)">
                    <button *ngIf="message.editableNow" type="button" (click)="startEdit(message)">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                      {{ editText }}
                    </button>
                    <button type="button" class="chat__menu-danger" (click)="deleteMessage(message)">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                      {{ deleteText }}
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div #scrollAnchor></div>
    </ng-container>
  </div>

  <div class="chat__locked-note" *ngIf="locked">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
    <span>{{ lockedHintText }}</span>
  </div>

  <div class="chat__composer" *ngIf="!locked">
    <div *ngIf="replyTarget" class="chat__reply-preview">
      <div class="chat__reply-preview-bar"></div>
      <div class="chat__reply-preview-text">
        <span class="chat__reply-sender">{{ replyingToText }} {{ senderLabel(replyTarget.sender) }}</span>
        <span class="chat__reply-text">{{ replyTarget.body }}</span>
      </div>
      <button type="button" class="chat__reply-cancel" (click)="cancelReply()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6L18 18"/></svg>
      </button>
    </div>

    <div *ngIf="selectedFiles.length" class="chat__selected-files">
      <span *ngFor="let file of selectedFiles; let i = index" class="chat__selected-file">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
        {{ file.name }}
        <button type="button" (click)="removeSelectedFile(i)">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6L18 18"/></svg>
        </button>
      </span>
    </div>

    <div *ngIf="sendError" class="chat__state chat__state--error">{{ sendError }}</div>

    <div class="chat__input-row">
      <label class="chat__attach-btn" [attr.aria-label]="attachFileText">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
        <input type="file" multiple hidden (change)="onFilesSelected($event)" />
      </label>
      <textarea
        #composerTextarea
        class="chat__textarea"
        [(ngModel)]="draft"
        [placeholder]="placeholderText"
        rows="1"
        (keydown)="onDraftKeydown($event)"
      ></textarea>
      <button type="button" class="chat__send-btn" [attr.aria-label]="sendLabelText" [disabled]="!canSend()" (click)="send()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><line x1="22" y1="2" x2="11" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
      </button>
    </div>
  </div>
</div>
